export const data = [
  {
    date: "sep 2022 - oct 2022",
    name: "Curso de React Native",
    img: "https://pbs.twimg.com/profile_images/1465705281279590405/1yiTdkKj_400x400.png",
    link: "https://www.coderhouse.cl/certificados/63cdbcf4c4b08f000e32cb1d",
  },
  {
    date: "Jul 2022 - Ago 2022",
    name: "Curso de React Js (Top 10)",
    img: "https://pbs.twimg.com/profile_images/1465705281279590405/1yiTdkKj_400x400.png",
    link: "https://www.coderhouse.cl/certificados/631604bcebc80c001a5d16af",
  },
];
